import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { faArrowTrendUp, faChevronLeft, faChevronRight, faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Chart, registerables } from 'node_modules/chart.js';
import { Observable, timer } from 'rxjs';
import { fadeIn, fadeOut, loadingValue } from 'src/app/animations';
import { DataService } from 'src/app/shared/services/data.service';
import { TokenService } from 'src/app/shared/services/token.service';
import { AceitesService } from '../../../services/saude/aceites.service';
import { HealthService } from '../../../services/saude/health.service';
Chart.register(...registerables);
@Component({
  selector: 'dashboard-saude',
  templateUrl: './dashboard-saude.component.html',
  styleUrls: ['./dashboard-saude.component.css'],
  animations: [fadeIn, fadeOut, loadingValue]
})
export class DashboardSaudeComponent implements OnInit, OnDestroy {
  formData: FormGroup = new FormGroup({
    ano: new FormControl(null),
    nationality: new FormControl(null, [Validators.required]),
  });
  // //Icons
  faCircleQuestion = faCircleQuestion;
  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
  faLine = faArrowTrendUp;
  chartCoparticipacao: any;
  chartReserva: any;
  chartPagamentos: any;
  totalValorPercent: number = 0;
  totalUtilizado!: Observable<number>;
  coparticipacao!: Observable<number>;
  patrocinadora!: Observable<number>;
  mensalidadeAtual!: Observable<number>;
  anos: any;
  anoSelecionadoSaude: any;
  costs: any = { totalYear: [], totalValueAllTime: 0, percent: 0 };
  beneficiaries: any[] = [];
  healthCardSide: number = 1;
  healthCardPerson: number = 0;
  actualUser: any;
  mesesBrasileiros: any[] = [];
  listaGastoUtilizacoes: any[] = [];
  listaCoparticipacao: any[] = [];
  listaReserva: any[] = [];
  listaPagamentos: any[] = [];
  composicaoReserva: any
  pgamentosFcopel!: { meses: any, data: any };
  pagamentosCoparticipacao!: { meses: any, data: any };
  loading: boolean = true;
  constructor(private healthService: HealthService, private router: Router, private modalService: NgbModal, private data: DataService, private aceitesService: AceitesService, private tokenService: TokenService, private datePipe: DatePipe) {
    this.totalUtilizado = this.getValue(0, 20);
    this.patrocinadora = this.getValue(0, 20);
    this.coparticipacao = this.getValue(0, 20);
    this.mensalidadeAtual = this.getValue(0, 20);
    this.actualUser = this.tokenService.getActiveUser();
    this.getBeneficiaries();
    this.getHealthCost();
    this.inicializarMeses();
  }
  getBeneficiaries() {
    this.healthService.getBeneficiaryAndHealthData().subscribe({
      next: (res: any) => {
        this.beneficiaries = res;
        this.data.list = res.filter((a: any) => a.titular);
      },
      error: (res: any) => { }
    });
  }
  changeDados() {
    if (this.healthCardSide == 1) {
      this.healthCardSide = 2;
    } else {
      this.healthCardSide = 1;
    }
  }
  getHealthCost() {
    this.loading = true;
    this.healthService.getHealthCostComplete().subscribe({
      next: (res: any) => {
        this.loading = false;
        this.costs = res;
        this.totalValorPercent = res.total;
        this.totalUtilizado = this.getValue(res.total, 10000);
        this.patrocinadora = this.getValue(res.sponsor, 10000);
        this.coparticipacao = this.getValue(res.paid, 10000);
        this.mensalidadeAtual = this.getValue(res.lastMonthlyFee?.totalValue, 10000);
        this.anos = res.totalYear.map((objeto: any) => objeto.year).reverse();
        this.anoSelecionado(this.anos[0]);
        this.formData.get('ano')?.setValue(this.anos[0]);

        console.log(this.mensalidadeAtual)
      }
    });
  }
  changeBeneficiary(index: any) {
    this.healthCardPerson = index;
  }
  nextBeneficiary() {
    if (this.beneficiaries && this.beneficiaries.length - 1 > this.healthCardPerson) this.healthCardPerson++;
    else this.healthCardPerson = 0;
  }
  prevBeneficiary() {
    if (0 != this.healthCardPerson) this.healthCardPerson--;
    else this.healthCardPerson = this.beneficiaries.length - 1;
  }
  anoSelecionado(event: any) {
    if (this.chartReserva) {
      this.chartReserva.destroy();
      this.chartCoparticipacao.destroy();
      this.chartPagamentos.destroy();
      this.listaReserva = [];
      this.listaPagamentos = [];
      this.listaCoparticipacao = [];
    }
    if (this.costs && this.costs.totalYear) {
      this.costs.totalYear.map(
        (ano: any) => {
          if (event == ano.year) {
            this.anoSelecionadoSaude = ano;
            this.listaGastoUtilizacoes = ano.person;
            ano.totalMonth.map((element: any) => {
              this.listaReserva.push(element.total);
            });
            ano.sponsorMonth.map((element: any) => {
              this.listaPagamentos.push(element.total);
            });
            ano.personMonth.map((element: any) => {
              this.listaCoparticipacao.push(element.total);
            });
            this.RenderChart();
            // ano.totalMonth.forEach( (element:any) => {
            //   debugger
            //   this.composicaoReserva.meses.push( this.mesesBrasileiros[element.month - 1] );
            //   this.composicaoReserva.data.push(element.total);
            // });
          }
        });
    }
  }
  ngOnChanges(changes: SimpleChanges) { }
  RenderChart() {
    this.chartReserva = new Chart('piechart', {
      type: 'line',
      data: {
        labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez',],
        datasets: [{
          label: 'R$',
          data: this.listaReserva,
          borderWidth: 1,
          backgroundColor: '#FFC6A0',
          fill: true,
          borderColor: '#D25401'
        }]
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            display: false,
            labels: {
              font: {
                size: 14
              }
            }
          },
          datalabels: {
            anchor: 'end',
            align: 'end',
            formatter: (value) => {
              return 'R$ ' + value;
            },
            font: {
              weight: 'bold',
              size: 12
            }
            // anchor: 'end', // Define a posição dos rótulos ("end" para extremidade)
            // align: 'top', // Define a orientação dos rótulos ("top" para cima)
            // color: 'black', // Cor dos rótulos
            // font: {
            //   weight: 'bold' // Peso da fonte dos rótulos
            // },
            // formatter: function(value, context) {
            //   // Formate o valor conforme necessário (por exemplo, arredonde-o)
            //   return Math.round(value);
            // }
          }
        },
        scales: {
          x: {
            beginAtZero: true,
            grid: {
              display: false
            },
            ticks: {
              font: {
                size: 10,
              }
            }
          },
          y: {
            beginAtZero: true,
            border: {
              display: false
            },
            grid: {
              display: false,
            },
            ticks: {
              display: false
            }
          }
        },
        layout: {
          padding: 30
        }
      }
    });
    this.chartPagamentos = new Chart('actualChart', {
      type: 'bar',
      data: {
        labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez',],
        datasets: [{
          label: 'R$',
          data: this.listaPagamentos,
          borderWidth: 2,
          borderColor: '#15346D',
          backgroundColor: '#CFDDF6',
        }]
      },
      options: {
        plugins: {
          legend: {
            display: false,
            labels: {
              // This more specific font property overrides the global property
              font: {
                size: 16
              }
            }
          },
          datalabels: {
            anchor: 'end',
            align: 'end',
            formatter: (value) => {
              return 'R$ ' + value;
            },
            font: {
              weight: 'bold',
              size: 12
            }
            // anchor: 'end', // Define a posição dos rótulos ("end" para extremidade)
            // align: 'top', // Define a orientação dos rótulos ("top" para cima)
            // color: 'black', // Cor dos rótulos
            // font: {
            //   weight: 'bold' // Peso da fonte dos rótulos
            // },
            // formatter: function(value, context) {
            //   // Formate o valor conforme necessário (por exemplo, arredonde-o)
            //   return Math.round(value);
            // }
          }
        },
        scales: {
          x: {
            beginAtZero: true,
            grid: {
              display: false
            },
            ticks: {
              font: {
                size: 10,
              }
            }
          },
          y: {
            beginAtZero: true,
            border: {
              display: false
            },
            grid: {
              display: false,
            },
            ticks: {
              display: false
            }
          }
        },
        layout: {
          padding: 30
        }
      }
    });
    this.chartCoparticipacao = new Chart('teste', {
      type: 'bar',
      data: {
        labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez',],
        datasets: [{
          label: 'R$',
          data: this.listaCoparticipacao,
          borderWidth: 2,
          borderColor: '#15346D',
          backgroundColor: '#CFDDF6',
        }]
      },
      options: {
        plugins: {
          legend: {
            display: false,
            labels: {
              // This more specific font property overrides the global property
              font: {
                size: 16
              }
            }
          },
          datalabels: {
            anchor: 'end',
            align: 'end',
            formatter: (value) => {
              return 'R$ ' + value;
            },
            font: {
              weight: 'bold',
              size: 12
            }
            // anchor: 'end', // Define a posição dos rótulos ("end" para extremidade)
            // align: 'top', // Define a orientação dos rótulos ("top" para cima)
            // color: 'black', // Cor dos rótulos
            // font: {
            //   weight: 'bold' // Peso da fonte dos rótulos
            // },
            // formatter: function(value, context) {
            //   // Formate o valor conforme necessário (por exemplo, arredonde-o)
            //   return Math.round(value);
            // }
          }
        },
        scales: {
          x: {
            beginAtZero: true,
            grid: {
              display: false
            },
            ticks: {
              font: {
                size: 10,
              }
            }
          },
          y: {
            beginAtZero: true,
            border: {
              display: false
            },
            grid: {
              display: false,
            },
            ticks: {
              display: false
            }
          }
        },
        layout: {
          padding: 30
        }
      }
    });
    // const pieChart = new Chart('testePie', {
    //   type: 'pie',
    //   data: {
    //     labels: 
    //       ['Total', '2023'],         
    //     datasets: [{
    //       label: 'R$',
    //       data: 
    //         ['100', '30'],
    //       borderWidth: 2,
    //       borderColor: ['#1A428A', '#FE7F2A'],
    //       backgroundColor: ['#1A428A', '#FE7F2A'],          
    //     }]        
    //   },
    //   options: {   
    //     offset: [0,15],
    //     responsive: true,
    //     plugins: {                 
    //       legend: {          
    //         display: false,
    //       },
    //       datalabels:{
    //         anchor: 'end',
    //         align: 'end',
    //         formatter: (value) => {              
    //           return Math.round((value) * 100) + '%';
    //         },
    //         font: {              
    //           weight: 'bold',
    //           size: 12
    //       }
    //       }
    //   },
    //   layout:{
    //     padding: 30
    //   }
    //  },
    // });
  }
  ngOnInit() {
    this.aceitesService.GetRecadastramento().subscribe((res: any) => {
      if (res.mostrarPopUp) {
        this.data.data = res;
      }
    });
  }
  animateValue() {
    let animationState = 'start';
    let animatedValue = 0;
    let finalValue = 100;
    const duration = 2000; // Duração da animação em milissegundos
    const increment = (finalValue / duration) * 100;
    const interval = setInterval(() => {
      if (animatedValue < finalValue) {
        animatedValue += increment;
      } else {
        clearInterval(interval);
      }
    }, 100);
  }
  inicializarMeses() {
    for (let i = 0; i < 12; i++) {
      const data = new Date(2000, i, 1); // Use qualquer ano (2000 é arbitrário)
      const mesBrasileiro = this.datePipe.transform(data, 'MMMM', 'pt-BR');
      this.mesesBrasileiros.push(mesBrasileiro);
    }
  }
  private getValue(finalValue: number, durationMs: number): Observable<number> {
    return new Observable<number>((observer: any) => {
      let startValue = 0;
      const stepValue = finalValue / (durationMs / 1000); // Ajuste a velocidade da animação
      const timerSubscription = timer(0, 50).subscribe(() => {
        startValue += stepValue;
        if (startValue >= finalValue) {
          observer.next(finalValue);
          observer.complete();
          timerSubscription.unsubscribe();
        } else {
          observer.next(startValue);
        }
      });
    });
  }
  ngOnDestroy(): void {
    if (this.chartReserva) {
      this.chartReserva.destroy();
    }
    if (this.chartCoparticipacao) {
      this.chartCoparticipacao.destroy();
    }
    if (this.chartPagamentos) {
      this.chartPagamentos.destroy();
    }
  }
}
